import React from "react";
import { FileText, AudioWaveform, Download } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Features() {
  const { t } = useLanguage();

  const FEATURES = [
    {
      n: "01",
      title: t("features.multiFormat_title"),
      desc: t("features.multiFormat_desc"),
      Icon: FileText,
    },
    {
      n: "02",
      title: t("features.voices_title"),
      desc: t("features.voices_desc"),
      Icon: AudioWaveform,
    },
    {
      n: "03",
      title: t("features.download_title"),
      desc: t("features.download_desc"),
      Icon: Download,
    },
  ];

  return (
    <section
      id="caracteristicas"
      data-testid="features-section"
      className="relative border-t border-zinc-200"
    >
      <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-16">
          <div className="lg:col-span-8">
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500 font-semibold">
              {t("features.kicker")}
            </span>
            <h2 className="mt-3 font-serif text-4xl sm:text-5xl leading-[1.05] tracking-tight text-zinc-950">
              {t("features.title_part1")}
              <span className="italic text-[#002FA7]">{t("features.title_emphasis")}</span>
              {t("features.title_end")}
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="font-sans text-base text-zinc-600 leading-relaxed">
              {t("features.subtitle")}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 border-t border-l border-zinc-200">
          {FEATURES.map(({ n, title, desc, Icon }) => (
            <div
              key={n}
              data-testid={`feature-card-${n}`}
              className="group relative border-r border-b border-zinc-200 p-8 lg:p-10 bg-white hover:bg-zinc-50/60 transition-colors duration-300"
            >
              <div className="flex items-start justify-between mb-8">
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400 font-semibold">
                  {n}
                </span>
                <div className="flex h-12 w-12 items-center justify-center rounded-md border border-zinc-200 bg-white group-hover:border-[#002FA7] group-hover:text-[#002FA7] transition-colors duration-300">
                  <Icon className="h-5 w-5" strokeWidth={1.8} />
                </div>
              </div>
              <h3 className="font-serif text-2xl text-zinc-950 leading-tight">
                {title}
              </h3>
              <p className="mt-4 font-sans text-sm leading-relaxed text-zinc-600">
                {desc}
              </p>
              <div className="mt-8 h-px w-8 bg-[#002FA7]/40 group-hover:w-16 transition-[width] duration-300" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
